import {Component, Input} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";

@Component({
  selector: "app-dashboard-button",
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <a
      [routerLink]="linkTarget"
      class="btn w-100 my-2"
      [class]="buttonClass"
      [ngClass]="spacingClass"
    >
      <div
        class="button-labeling d-flex d-row align-items-center justify-content-center p-3"
      >
        <i class="display-6 pe-3" [class]="icon"></i>
        <span class="font-base">{{ label }}</span>
      </div>
    </a>
  `,
  styles: [],
})
export class DashboardButtonComponent {
  @Input() icon: string = "";
  @Input() label: string = "";
  @Input() linkTarget: string = "";
  @Input() buttonClass: string = "";
  @Input() spacingClass: string = "py-2 my-2"
}
